<template>
  <swiper class="swiperWrap" ref="mySwiper" :options="swiperOption">
    <swiper-slide v-for="(value, index) in showImgList" :key="index" class="slider">
      <a-icon type="zoom-in" class="iconfont" @click="showBig(1)" />

      <img
        src="@/assets/design/unique.png"
        alt=""
        v-if="value ? value.is_user_show_image === 1 : false"
        class="unique"
      />
      <img :src="value ? value.layerImg : ''" alt="" :style="{ zIndex: value && value.over }" />
      <img :src="value ? value.designImg : ''" alt="" style="z-index:0" />
      <!-- <span v-html="value ? value.designImg : ''"></span> -->
      <!-- {{}} -->
    </swiper-slide>
    <div class="swiper-pagination" slot="pagination"></div>
    <!-- 分页 -->
    <div class="swiper-button-prev" slot="button-prev"></div>
    <!-- 箭头左 -->
    <div class="swiper-button-next" slot="button-next"></div>
    <a-modal
      :visible="visible"
      @cancel="
        () => {
          visible = false
        }
      "
      :getContainer="() => document.getElementById('app')"
      :footer="null"
      width="768px"
      title="Preview images"
    >
      <!-- showImgListBig -->
      <swiper ref="mySwiper1" :options="swiperOption1" v-if="false">
        <swiper-slide v-for="(value, index) in showImgListBig" :key="index" class="sliderBig" style="height:600px">
          <!-- <img
            src="@/assets/design/unique.png"
            alt=""
            v-if="value ? value.is_user_show_image === 1 : true"
            class="unique"
            style="position:absolute;z-index:999"
          /> -->
          <ImgLoading
            :src="value && value.layerImg ? value.layerImg : 'none'"
            alt=""
            :style="{ zIndex: value && value.over, position: 'absolute' }"
            height="600"
            width="600"
          />
          <ImgLoading
            :src="value && value.designImg ? value.designImg : 'none'"
            alt=""
            style="z-index:0;position:absolute"
            width="600"
            height="600"
          />
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
        <!-- 分页 -->
        <div class="swiper-button-prev" slot="button-prev"></div>
        <!-- 箭头左 -->
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
      <div class="bigImgBox">
        <div class="bigImgWrap clearFix">
          <div class="leftGig">
            <template v-if="Object.keys(curBigImg).length">
              <!-- <ImgLoading
                src="@/assets/design/unique.png"
                alt=""
                v-if="curBigImg ? curBigImg.is_user_show_image === 1 : true"
                class="unique"
                style="position:absolute;z-index:999"
              /> -->
              <ImgLoading
                :src="curBigImg && curBigImg.layerImg ? curBigImg.layerImg : 'none'"
                alt=""
                :style="{ zIndex: curBigImg && curBigImg.over + 1, position: 'absolute' }"
                height="598"
                width="598"
              />
              <ImgLoading
                :src="curBigImg && curBigImg.designImg ? curBigImg.designImg : 'none'"
                alt=""
                style="z-index:1;position:absolute"
                width="598"
                height="598"
              />
            </template>
          </div>
          <div class="rightGig">
            <div class="btnWrap btnTop" @click="srollLeftFn(2)"></div>
            <div class="btnWrap btnDown" @click="srollLeftFn(1)"></div>
            <div class="slide-hidden">
              <div class="slide-sroll" :style="transformLeft" ref="transformLeft">
                <div
                  class="slide-item"
                  v-for="(value, i) in showImgListBig"
                  :key="i"
                  :class="{ on: slideIndex === i }"
                  @click="
                    slideIndex = i
                    curBigImg = value
                  "
                >
                  <ImgLoading
                    :src="value && value.layerImg ? value.layerImg : 'none'"
                    alt=""
                    :style="{ zIndex: value && value.over, position: 'absolute' }"
                  />
                  <ImgLoading
                    :src="value && value.designImg ? value.designImg : 'none'"
                    alt=""
                    style="z-index:0;position:absolute"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="colorWrap" v-if="printImgInfo.colors && printImgInfo.colors.length > 1">
          <span
            :class="{ on: +showColor === +it.id }"
            :title="it.name"
            :style="{ background: it.tone }"
            @click="changeColor(it.id)"
            v-for="(it, itI) in printImgInfo.colors"
            :key="itI"
          ></span>
        </div>
      </div>
    </a-modal>
  </swiper>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import { mapState, mapGetters, mapMutations } from 'vuex'
import store from '@/store'
import { mergeImg } from '@/utils/util'
import ImgLoading from '@/views/components/imgLoading'
export default {
  name: 'Slide',
  data() {
    const that = this

    return {
      visible: false,
      curBigImg: {},
      slideIndex: 0,
      leftNum: 0,
      swiperOption: {
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        on: {
          slideChange: function() {
            store.commit('SET_SLIDER_INDEX', this.activeIndex)
            that.$nextTick(() => {
              that.setRandom()
            })
          }
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      swiperOption1: {
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  components: {
    Swiper,
    SwiperSlide,
    ImgLoading
  },
  watch: {
    basic_product_id() {
      this.changeIndex(0)
    }
  },
  methods: {
    ...mapMutations({
      setRandom: 'SET_RANDOM',
      setSliderIndex: 'SET_SLIDER_INDEX',
      setPrice: 'SET_PRICE',
      setColor: 'SET_INITIAL_COLOR',
      setShowColor: 'SET_SHOW_COLOR'
    }),
    changeColor(val) {
      if (+val === +this.showColor) {
        return
      }
      this.setShowColor(val)
      this.curBigImg = {}
      this.setRandom()
      setTimeout(() => {
        this.$nextTick(() => {
          this.showBig()
        })
      }, 500)
    },
    srollLeftFn(str) {
      if (this.slideWidth === 0) {
        // 首次获取切换展示图宽度
        const H = this.$refs.transformLeft
        this.slideWidth = H.offsetHeight
      }
      if (str === 1) {
        if (-this.leftNum + 428 >= this.slideWidth) {
          this.leftNum = 0
        } else {
          this.leftNum = this.leftNum - 428
        }
      } else {
        if (-this.leftNum < this.slideWidth - 428) {
          this.leftNum = this.leftNum - 428
        } else {
          this.leftNum = 0
        }
      }
    },
    async showBig(n) {
      store.commit('SET_LOADING', true)
      this.visible = true
      if (n) {
        this.setShowColor(+this.initialColor)
      }
      await mergeImg(1)
      this.slideIndex = 0
      this.leftNum = 0
      this.slideWidth = 0
      // setTimeout(() => {
      //   this.curBigImg = this.showImgListBig && this.showImgListBig.length ? this.showImgListBig[0] : {}
      // }, 1000)
      this.curBigImg = this.showImgListBig && this.showImgListBig.length ? this.showImgListBig[0] : {}
      store.commit('SET_LOADING', false)
    },
    changeIndex(index) {
      const swiper = this.$refs.mySwiper.$swiper
      console.log(swiper)

      swiper.slideTo(index, 300, false)
    }
  },

  created() {
    this.setSliderIndex(0)
  },
  mounted() {
    this.changeIndex(0)
  },
  computed: {
    ...mapState({
      printImgInfo: state => state.design.printImgInfo,
      showImgList: state => state.design.showImgList,
      showImgListBig: state => state.design.showImgListBig,
      basic_product_id: state => state.design.basic_product_id,
      initialColor: state => state.design.initialColor,
      initialSize: state => state.design.initialSize,
      showColor: state => state.design.showColor
    }),
    transformLeft() {
      return {
        transform: `translate3d(0px, ${this.leftNum}px, 0px)`
      }
    },
    ...mapGetters(['show_images_design'])
  }
}
</script>

<style scoped lang="less">
.swiper-button-prev:after,
.swiper-button-next:after {
  font-size: 20px;
}
.slider {
  height: 280px;
  img {
    position: absolute;
    height: 280px;
  }
  .iconfont {
    position: absolute;
    right: 15px;
    top: 10px;
    font-size: 24px;
    z-index: 999;
    &:hover {
      cursor: pointer;
    }
  }

  .unique {
    position: absolute;
    left: -2px;
    top: 0;
    height: auto;
    z-index: 999;
  }
}
.leftGig {
  overflow: hidden;
  float: left;
  width: 600px;
  height: 600px;
  border: 1px solid #d9d9d9;
  border-radius: 12px;
  img {
    border-radius: 12px;
  }
}
.rightGig {
  float: left;
  position: relative;
  padding: 30px 0;
  margin-left: 20px;
  width: 100px;
  height: 500px;
  .btnWrap {
    position: absolute;
    left: 0;
    right: 0;
    height: 30px;
    border-radius: 15px;
    cursor: pointer;
    z-index: 999;
    &.btnTop {
      top: 0;
      font-size: 10px;
      background: url('../../../../assets/design/btn_t.png') center center #f2f3f7 no-repeat;
    }
    &.btnDown {
      bottom: 0;
      font-size: 10px;
      background: url('../../../../assets/design/btn_d.png') center center #f2f3f7 no-repeat;
    }
  }
  .slide-hidden {
    overflow: hidden;
    height: 428px;
    cursor: pointer;
    .slide-sroll {
      transition: -webkit-transform 500ms ease 0s;
      transition: transform 500ms ease 0s;
    }
    .slide-item {
      overflow: hidden;
      width: 100px;
      height: 100px;
      border: 1px solid #d9d9d9;
      border-radius: 12px;
      margin-top: 8px;
      &.on {
        border: 1px solid #3262fd;
      }
      img {
        width: 98px;
        border-radius: 12px;
      }
    }
  }
}
.colorWrap {
  margin-top: 20px;
  text-align: center;
  span {
    display: inline-block;
    width: 40px;
    height: 20px;
    margin: 0 6px;
    border: 1px solid #d9d9d9;
    border-radius: 10px;
    cursor: pointer;
    &.on {
      border: 1px solid #3262fd;
    }
  }
}
.icon-Group-:before {
  content: '\e69f';
}
</style>
